import { render, staticRenderFns } from "./FetchData.vue?vue&type=template&id=1d03fe08&scoped=true&"
import script from "./FetchData.vue?vue&type=script&lang=js&"
export * from "./FetchData.vue?vue&type=script&lang=js&"
import style0 from "./FetchData.vue?vue&type=style&index=0&id=1d03fe08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d03fe08",
  null
  
)

export default component.exports